// Tranlsation
import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var TranslationService = /** @class */ (function () {
    /**
     * Service Constructor
     *
     * @param translate: TranslateService
     */
    function TranslationService(translate) {
        this.translate = translate;
        // Private properties
        this.langIds = [];
        // add new langIds to the list
        this.translate.addLangs(['en', 'ar']);
        // this language will be used as a fallback when a translation isn't found in the current language
        this.translate.setDefaultLang('en');
    }
    /**
     * Load Translation
     *
     * @param args: Locale[]
     */
    TranslationService.prototype.loadTranslations = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var locales = args.slice();
        locales.forEach(function (locale) {
            // use setTranslation() with the third argument set to true
            // to append translations instead of replacing them
            _this.translate.setTranslation(locale.lang, locale.data, true);
            _this.langIds.push(locale.lang);
        });
        // add new languages to the list
        this.translate.addLangs(this.langIds);
    };
    /**
     * Setup language
     *
     * @param lang: any
     */
    TranslationService.prototype.setLanguage = function (lang) {
        var langDefault = this.translate.getDefaultLang();
        if (!lang) {
            lang = langDefault;
        }
        this.translate.use(lang);
        localStorage.setItem('language', lang);
        this.changeLanguage(lang);
    };
    TranslationService.prototype.changeLanguage = function (lang) {
        var isRTL = lang === 'ar' || lang === 'ur';
        var rtlStylesheets = [
            { href: 'assets/plugins/bootstrap/css/bootstrap-rtl.css', ltrHref: 'assets/plugins/bootstrap/css/bootstrap.css' },
            { href: 'assets/css/style.angular.rtl.css', ltrHref: 'assets/css/style.angular.css' },
        ];
        var ltrStylesheets = [
            { href: 'assets/plugins/bootstrap/css/bootstrap.css', rtlHref: 'assets/plugins/bootstrap/css/bootstrap-rtl.css' },
            { href: 'assets/css/style.angular.css', rtlHref: 'assets/css/style.angular.rtl.css' },
        ];
        var stylesheets = isRTL ? rtlStylesheets : ltrStylesheets;
        stylesheets.forEach(function (_a) {
            var href = _a.href, ltrHref = _a.ltrHref, rtlHref = _a.rtlHref;
            var existingLinkElement = document.querySelector("link[rel=\"stylesheet\"][href=\"" + href + "\"]");
            if (!existingLinkElement) {
                var linkElement = document.createElement('link');
                linkElement.rel = 'stylesheet';
                linkElement.href = href;
                linkElement.onload = function () {
                    var oppositeLinkElement = document.querySelector("link[href=\"" + (isRTL ? ltrHref : rtlHref) + "\"]");
                    if (oppositeLinkElement) {
                        oppositeLinkElement.remove();
                    }
                };
                var viewportMetaTag = document.querySelector('meta[name="viewport"]');
                if (viewportMetaTag) {
                    document.head.insertBefore(linkElement, viewportMetaTag.nextSibling);
                }
                else {
                    document.head.insertBefore(linkElement, document.head.firstChild);
                }
            }
            else {
                var oppositeLinkElement = document.querySelector("link[href=\"" + (isRTL ? ltrHref : rtlHref) + "\"]");
                if (oppositeLinkElement) {
                    oppositeLinkElement.remove();
                }
            }
        });
        this.updateHtmlAttributes(lang, isRTL);
        this.updateBodyClasses(isRTL);
    };
    TranslationService.prototype.updateHtmlAttributes = function (lang, isRTL) {
        var htmlElement = document.documentElement;
        var direction = isRTL ? 'rtl' : 'ltr';
        htmlElement.setAttribute('lang', lang);
        htmlElement.setAttribute('direction', direction);
        htmlElement.setAttribute('dir', direction);
        htmlElement.style.direction = direction;
    };
    TranslationService.prototype.updateBodyClasses = function (isRTL) {
        var bodyElement = document.body;
        var classList = bodyElement.classList;
        if (isRTL) {
            classList.add('custom-rtl');
            classList.remove('custom-ltr');
        }
        else {
            classList.add('custom-ltr');
            classList.remove('custom-rtl');
        }
    };
    /**
     * Returns selected language
     */
    TranslationService.prototype.getSelectedLanguage = function () {
        return localStorage.getItem('language') || this.translate.getDefaultLang();
    };
    TranslationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TranslationService_Factory() { return new TranslationService(i0.ɵɵinject(i1.TranslateService)); }, token: TranslationService, providedIn: "root" });
    return TranslationService;
}());
export { TranslationService };
